import { createApp } from 'vue';
import Vacancies from '../vue/Vacancies.vue';

export default class VacancyComponent {
    constructor(el) {
        this.el = el;

        this.vueComponent = createApp(Vacancies, {
            data: JSON.parse(this.el.querySelector('script').textContent),
        })
        this.vueComponent.mount(this.el);
    }
}
